
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const powerOpportunityChallenge: Challenge = {
  id: 'power-opportunity',
  title: 'Renewable Energy Opportunity',
  description: 'A local renewable energy project is seeking partners for a power purchase agreement.',
  options: [
    {
      text: 'Negotiate a long-term fixed-rate agreement',
      outcome: 'You secured stable, predictable energy costs for the next 5 years.',
      kpiEffects: {
        energyCost: -0.02,
        profitMargin: 3
      },
      experienceGain: 20,
      skillUnlock: skills.find(s => s.id === 'renewable-energy')!
    },
    {
      text: 'Invest in the project as a co-owner',
      outcome: 'Your investment gives you partial ownership and very favorable rates, but required significant capital.',
      kpiEffects: {
        energyCost: -0.03,
        profitMargin: -5
      },
      experienceGain: 30
    },
    {
      text: 'Decline and stick with current energy providers',
      outcome: 'You avoided commitment but missed an opportunity to reduce costs.',
      kpiEffects: {},
      experienceGain: 5
    }
  ],
  difficulty: 2
};
